export const haveInstagramMetricsStore = (time?: number) => {
  // The cut date of Instagram Metric Store is 2017/01/01
  const igMetricStoreCutDate = Date.UTC(2017, 0, 1)
  if (time && time < igMetricStoreCutDate) {
    return false
  }
  return true
}

export const haveYoutubeMetricsStore = (time?: number) => {
  // The cut date of Youtube Metric Store is 2017/12/05
  const ytMetricStoreCutDate = Date.UTC(2017, 11, 5)
  if (time && time < ytMetricStoreCutDate) {
    return false
  }
  return true
}
